import { Component, Input, OnChanges } from '@angular/core';
import { IProducerBgImage } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';

import { IProducerOptions } from '../../Contract';

import styles from './VideoPreview.module.less';

@Component({
	selector: 'onstage-view',
	templateUrl: './OnstageView.Component.html',
	standalone: false
})
export class OnstageViewComponent implements OnChanges {
	@Input() public producerOptions: IProducerOptions;
	@Input() public bgImages: IProducerBgImage[];
	@Input() public isProducer: boolean;
	@Input() public broadcasting: boolean;

	public helperText = 'Event_Producer_OnstageWindow';
	public readonly styles = styles;

	public ngOnChanges(): void {
		if (this.producerOptions.onStageLayout.videos?.length > 0) {
			this.helperText = '';
		}
	}
}
